import script from "./VideoGeoblockRuleOptionField.vue?vue&type=script&setup=true&lang=ts"
export * from "./VideoGeoblockRuleOptionField.vue?vue&type=script&setup=true&lang=ts"

import "./VideoGeoblockRuleOptionField.vue?vue&type=style&index=0&id=60facc97&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60facc97"]])

export default __exports__